'use strict';

angular.module('mandaeApp')
  .factory('Parametro', function ($rootScope, $http, $q, $cacheFactory, $filter, API_TOKEN, $resource, ParametroResource) {

    var cacheParametro = $cacheFactory('parametro');

    return {

      /**
       * Retorna um parâmetro pelo seu código.
       *
       * @param  {Object}   codigoParametro - codigo do parametro
       * @param  {Function} callback - optional
       * @return {Promise}
       */
      busca: function(codigoParametro, callback) {

        var cb = callback || angular.noop;
        var deferred = $q.defer();

        var parametro = cacheParametro.get(codigoParametro);

        if (parametro) {
          deferred.resolve(parametro);
          return deferred.promise;
        } else {
          return ParametroResource.get({ codigo:codigoParametro }, 
            function(data) {
              cacheParametro.put(codigoParametro, data);
              deferred.resolve(data);
              return cb();
            }, function(err) {
              return cb(err);
            }.bind(this)).$promise;
        }
      }

    };
  });